<div>
    <kendo-datepicker placeholder="DD/MM/YYYY"
    class="{{className}}"
    format="dd/MM/yyyy"
          [formatPlaceholder]="{
            year: 'YYYY',
            month: 'MM',
            day: 'DD'
          }"
    [readonly]="calDisable"
    [disabled]="disableCalender"
    (valueChange)="onChange($event)"
    [value]="selectedValue"
    [incompleteDateValidation]="true"></kendo-datepicker>
</div>